import { Input, Component, EventEmitter, Output, OnChanges, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import { FlowTemplate, Option } from "../../../common/models/flow.dto";
import { ContextPair, ContextOption, ContextHelper } from "../../models/template-context.model";
import { HeightWidthService, IHeightWidth } from "../../../common/services/height-width.service";
import { FlowTemplateService } from "../../services/flow-template.service";
import { Subscription ,  BehaviorSubject } from "rxjs";

@Component({
    templateUrl: "./workflow-context-tree.component.html",
    selector: "workflow-context-tree",
    providers: [FlowTemplateService],
    standalone: false
})

export class WorkflowContextTreeComponent implements OnInit, OnChanges, OnDestroy {
    @Input() template: FlowTemplate;
    
    contextData: any;
    contextOptions = new Array<Option>(); 
    heightWidth: IHeightWidth;
    hwSubscription: Subscription;
    keys: any;

    @Output() contextCopied = new EventEmitter<string>();
    loading$ = new BehaviorSubject<boolean>(true);
    
    
    templateSubscription: Subscription;

    constructor(public readonly flowService: FlowTemplateService, public heightWidthService: HeightWidthService) {
        
    }

    ngOnInit() {
        this.hwSubscription = this.heightWidthService.getHW().subscribe(hw => {
            this.heightWidth = hw;
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["template"]) {
            this.subscribeToContext();
        }
    }

    ngOnDestroy() {
        if (this.templateSubscription) {
            this.templateSubscription.unsubscribe();
        }
        if (this.hwSubscription) {
            this.hwSubscription.unsubscribe();
        }
    }

    copyContext(contextValue: string): void {
        this.contextCopied.emit(contextValue);
    }

    refreshView(refresh: boolean): void {
        this.loading$.next(true);
        setTimeout(() => {
            this.keys = Object.keys(this.contextData);
            this.loading$.next(false);
            this.heightWidthService.sendHW(this.heightWidth);
        }, 1);            
    }
    

    subscribeToContext(): void {
        this.loading$.next(true);
        this.templateSubscription = this.flowService.getContextMap(this.template.workflowId, this.template.majorVersion, this.template.minorVersion).subscribe((context) => {           
            this.contextData = context;            
            this.keys = Object.keys(this.contextData);
            this.template.context.model = this.contextData;
            this.loading$.next(false);
            this.heightWidthService.sendHW(this.heightWidth);
        }, (error) => {
            console.error(error);
        });
    }
}